<template>
  <p class="divider-text">{{ dividerText }}</p>
</template>

<script>
export default {
  name: "DividerWithText",
  props: {
    dividerText: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.divider-text {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  &:before {
    margin-right: 20px;
    margin-left: 30px;
  }
  &:after {
    margin-left: 20px;
    margin-right: 30px;
  }
}

.divider-text:before,
.divider-text:after {
  content: "";
  flex: 1 1;
  border-bottom: 1px solid $color-font-color;
  margin-top: auto;
  margin-bottom: auto;
}
</style>
